/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

/**
 * Base styles for the story card component
 *
 * @param {StoryCardProps} props The story card properties object
 * */
const baseStyles = css`
    height: 100%;
    box-shadow: var(--effects-shadow-base);
    background-color: var(--colors-surface-primary);
    border-radius: 0.8rem;
    overflow: hidden;

    a:hover .story-card-thumbnail {
        opacity: 0.8;
    }

    .story-card-thumbnail-link {
        display: block;
    }

    .story-card-thumbnail {
        position: relative;
        padding-top: 56.25%; // 16:9 ratio
        overflow: hidden;
        transition: opacity 0.3s ease-in-out;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
        }
    }

    .story-card-content {
        padding: var(--layout-spacing-12) var(--layout-spacing-16) 0.8rem
            var(--layout-spacing-16);
    }

    .story-card-date {
        color: var(--colors-text-secondary);
        ${theme.typography.caption};
    }

    .story-card-title {
        display: block;
        h3 {
            margin: var(--layout-spacing-12) 0;
        }
    }

    .story-card-teaser {
        font-size: 1.6rem;
        line-height: 2.4rem;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .story-card-footer {
        padding: 0 var(--layout-spacing-16) var(--layout-spacing-16)
            var(--layout-spacing-16);
    }
`;

/**
 * Skeleton styles for the story card component
 *
 * @param {StoryCardProps} props The story card properties object
 * */
const skeletonStyles = css`
    .story-card-thumbnail-skeleton {
        position: relative;
        padding-top: 56.25%; // 16:9 ratio
        overflow: hidden;
        border-radius: 0.4rem;
        .skeleton {
            position: absolute;
            top: 0;
        }
    }

    .story-card-date-skeleton {
        margin-top: 1.2rem;
        .skeleton {
            max-width: 15rem;
        }
    }

    .story-card-title-skeleton {
        .skeleton {
            margin-top: 1.8rem;
            line-height: 1.8;
        }
    }

    .story-card-footer-skeleton {
        .skeleton {
            max-width: 15rem;
            align-self: flex-end;
        }
    }

    .story-card-content-type {
        position: absolute;
        top: 0.8rem;
        left: 0.8rem;
    }
`;

/**
 * The story card component styles
 *
 * @param {StoryCardProps} props The story card properties object
 * */
export const styles = css`
    ${baseStyles}
    ${skeletonStyles}
`;
